import { h } from 'preact';
import { CloseIcon } from '../utils/icons';

export function GameOverlay({ children }) {
    return <div class="fixed inset-0 bg-slate-950 p-4 z-50">{children}</div>
}

export function ModalWrapper({ children }) {
    return <div class="h-full w-full flex flex-col">{children}</div>
}

export function ModalTop({ children }) {
    return <div class="flex-none h-10 w-full bg-slate-200 text-slate-950 flex items-center justify-between p-2 gap-2">{children}</div>
}

export function ModalTopTitle({ children }) {
    return <div class="pl-2 text-xl text-left grow min-w-0 truncate">{children}</div>
}

export function ModalTopButton({ children, onClick }) {
    return <div onClick={onClick} class="h-6 w-6 p-0.5 flex-0 rounded-xs bg-slate-300 text-slate-600 flex items-center justify-center">{children}</div>
}

export function ModalContent({ children }) {
    return <div class="bg-black grow">{children}</div>
}

function ExampleGame() {
    return <GameOverlay>
        <ModalWrapper>
            <ModalTop>
                <ModalTopTitle>Test game</ModalTopTitle>
                <ModalTopButton><CloseIcon class="h-4" /></ModalTopButton>
            </ModalTop>
            <ModalContent>

            </ModalContent>
        </ModalWrapper>
    </GameOverlay>
}